import { actions } from 'app-webtech-core';
import { get } from 'lodash';
import { redirect } from 'app-source/actions/redirect';
import {
  fetchViralClips,
  isEnabled as enableViral,
  playViralClip,
} from 'app-modules/viral/actions';
import { WATCH } from '../types';

function waitState(
  getState,
  selector,
  compareFunction = (value) => value !== undefined,
  checkRate = 100,
  timeout = 10000000,
) {
  return new Promise((resolve, reject) => {
    let timeoutRef;
    const interval = setInterval(() => {
      const value = selector(getState());
      if (compareFunction(value)) {
        clearInterval(interval);
        if (timeoutRef) {
          clearTimeout(timeoutRef);
        }
        resolve(value);
      }
    }, checkRate);
    if (timeout > 0) {
      timeoutRef = setTimeout(() => {
        clearInterval(interval);
        reject(new Error('Timeout'));
      }, timeout);
    }
  });
}

const viralEnabledCheckThunk = async (getState) => {
  if (get(getState(), 'application.setup.isServer')) {
    return true;
  }
  await waitState(
    getState,
    (state) => get(state, 'application.isConfigured'),
    (value) => value === true,
  );
};

function viralThunk(notValidItem, notPlaying) {
  return async (dispatch, getState) => {
    try {
      const response = await viralEnabledCheckThunk(getState);
      if (response) {
        return response;
      }
      dispatch(enableViral(true));
      dispatch(actions.application.appLaunchTrack(true));
      const viralSlug = get(getState(), 'location.payload.slug');
      await dispatch(fetchViralClips({ viralSlug }));
      if (!viralSlug) {
        return dispatch(
          redirect({
            type: WATCH,
          }),
        );
      }
      const state = getState();
      const clips = get(state, 'viral.content.clips');
      // The last clip in clips always is going to be the initial clip where opens up with the slug in url
      const initialViralClip = clips[clips.length - 1];
      if (initialViralClip._id !== '') {
        notPlaying(dispatch, initialViralClip);
      } else if (notValidItem) {
        notValidItem(dispatch);
      }
    } catch (err) {
      console.error('Thunk Error:', err);
    }
  };
}

export const viralRouteThunk = viralThunk(
  (dispatch) => {
    dispatch(redirect({ type: WATCH }));
  },
  (dispatch, clip) => {
    dispatch(playViralClip({ id: clip._id, slug: clip.slug }));
  },
);
